import api from "./axios";
import type { User } from "../context/AuthContext.tsx";

export const loginRequest = async (
  username: string,
  password: string
): Promise<User> => {
  const response = await api.post("/auth/login", { username, password });
  return response.data;
};